import { Action } from 'shared/store/types';
import EVENTS from './actionTypes';
import { VariantsState } from './types';


const defaultState: VariantsState = {
  loading: false,
  isNotFound: false,
  isFetchingError: false,
  data: [],
};

interface VariantsAction extends Action {
  productId? : number;
}


const Variants = (
  state = defaultState,
  action: VariantsAction,
) => {
  const { type, payload } = action;
  switch (type) {
    case EVENTS.FETCH_VARIANTS_PROGRESS: {
      return {
        ...state,
        loading: true,
        isNotFound: false,
        isFetchingError: false,
      };
    }


    case EVENTS.FETCH_VARIANTS_SUCCESS: {
      const { productId } = action;
      return {
        ...state,
        data: {
          ...state.data, [productId]: payload,
        },
        loading: false,
        isNotFound: false,
        isFetchingError: false,
      };
    }

      case EVENTS.FETCH_VARIANTS_NOT_FOUND: {
        return {
          ...state,
          loading: false,
          isNotFound: true,
          isFetchingError: false,
        };
      }


      case EVENTS.FETCH_VARIANTS_FAILED: {
        return {
          ...state,
          loading: false,
          isNotFound: false,
          isFetchingError: true,
        };
      }

    default:
      return state;
  }
};


export default Variants;
